import axios from 'axios'
import authHeader from './auth-header'

class MatriculaTrackingService {
  getSessionId () {
    const key = 'matriculaTrackingSessionId'
    let sessionId = localStorage.getItem(key)

    if (!sessionId) {
      sessionId = `matricula-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
      localStorage.setItem(key, sessionId)
    }

    return sessionId
  }

  newSessionId () {
    const key = 'matriculaTrackingSessionId'
    const sessionId = `matricula-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
    localStorage.setItem(key, sessionId)

    return sessionId
  }

  track (data) {
    const payload = {
      ...data,
      sessionId: data.sessionId || this.getSessionId(),
      origem: data.origem || 'apollo',
      rota: data.rota || window.location.pathname
    }

    return axios
      .post(process.env.VUE_APP_API_URL + 'matricula/tracking', payload, { headers: authHeader() })
      .catch(() => null)
  }

  list (params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking', { params, headers: authHeader() })
  }

  summary (params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking/resumo', { params, headers: authHeader() })
  }

  filters (params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking/filtros', { params, headers: authHeader() })
  }

  dashboard (params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking/dashboard', { params, headers: authHeader() })
  }

  table (params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking/tabela', { params, headers: authHeader() })
  }

  download (params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking/export', {
      params,
      headers: authHeader(),
      responseType: 'blob'
    })
  }

  detail (idMatricula) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking/detalhe/' + idMatricula, { headers: authHeader() })
  }

  stalled (params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'matricula/tracking/paradas', { params, headers: authHeader() })
  }
}

export default new MatriculaTrackingService()
